import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type LoginFormRows = {
  label: string;
  id: vp.BankLoginFormId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

const buildLoginFormRows = (): LoginFormRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'OnlineBanking' });
  return [
    {
      label: `${t('loginLabel')}`,
      id: vp.BankLoginFormId.Username,
      required: true,
      preset: 'text',
    },
    {
      label: `${t('loginPassword')}`,
      id: vp.BankLoginFormId.Password,
      required: true,
      preset: 'password',
    },
  ];
};

export default buildLoginFormRows;
